import React from 'react'
import { useNavigate } from 'react-router-dom';

export default function ShopDetails() {
	//retailer-document
	const navigate = useNavigate();
    const handleSubmit = () =>{
        navigate('/retailer-document')
    }
  return (
    <div class="mid-contant">
	<div class="container">		
		<div class="row">
			<div class="col-12">
				<div class="head">
					<h2> Retailer Business Details</h2>
				</div>
			</div>
			
			<div class="col-12">
				<div class="registerbox">
					<div class="row mb-3">
						<div class="col-12 col-lg-7">
							<form onClick={handleSubmit} >
							<div class="row">								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="name" placeholder="Enter shop name" value=""/>
										<label for="nmae">Shop/Business name</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<select class="form-select" id="type">
											<option value="">Select</option>
											<option value="1">Kirana Shop</option>
											<option value="2">Restaurant</option>
											<option value="3">Medical Shop</option>
										</select>
										<label for="type">Select Shop Type</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="add1" placeholder="Enter Address" value=""/>
										<label for="add1">Address line 1</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="add2" placeholder="Enter Address" value=""/>
										<label for="add2">Address line 2</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">						
								<div class="form-floating">
									<select class="form-select" id="state">
										<option value="">Select</option>
										<option value="Andhra Pradesh">Andhra Pradesh</option>
										<option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
										<option value="Arunachal Pradesh">Arunachal Pradesh</option>
										<option value="Assam">Assam</option>
										<option value="Bihar">Bihar</option>
										<option value="Chandigarh">Chandigarh</option>
										<option value="Chhatisgarh">Chhatisgarh</option>
										<option value="Dadra and Nagar Haveli">Dadra and Nagar Haveli</option>
										<option value="Daman and Diu">Daman and Diu</option>
										<option value="Delhi NCR">Delhi NCR</option>
										<option value="Goa">Goa</option>
										<option value="Gujarat">Gujarat</option>
										<option value="Haryana">Haryana</option>
										<option value="Himachal Pradesh">Himachal Pradesh</option>
										<option value="Jammu & Kashmir">Jammu & Kashmir</option>
										<option value="Jharkhand">Jharkhand</option>
										<option value="Karnataka">Karnataka</option>
										<option value="Kerala">Kerala</option>
										<option value="Ladakh">Ladakh</option>
										<option value="Lakshadweep">Lakshadweep</option>
										<option value="Madhya Pradesh">Madhya Pradesh</option>
										<option value="Maharashtra">Maharashtra</option>
										<option value="Manipur">Manipur</option>
										<option value="Mizoram">Mizoram</option>
										<option value="Nagaland">Nagaland</option>
										<option value="Odisha">Odisha</option>
										<option value="Puducherry">Puducherry</option>
										<option value="Punjab">Punjab</option>
										<option value="Rajasthan">Rajasthan</option>
										<option value="Sikkim">Sikkim</option>
										<option value="Tamilnadu">Tamilnadu</option>
										<option value="Telangana">Telangana</option>
										<option value="Tripura">Tripura</option>
										<option value="Uttar Pradesh">Uttar Pradesh</option>
										<option value="Uttarakhand">Uttarakhand</option>
										<option value="West Bengal">West Bengal</option>
									</select>
									<label for="state">Select state</label>
								</div>
								</div>
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="city" placeholder="Enter City" value=""/>
										<label for="city">City name</label>
									</div>
								</div>
								
								
								<div class="col-12 col-md-6">
									<div class="form-floating">
										<input type="text" class="form-control" id="pincode" placeholder="Enter pincode" value=""/>
										<label for="pincode">Pincode</label>
									</div>
								</div>
								
								<div class="col-12 col-md-6">
										<div class="file-upload">	
											<div class="dropzone-wrapper">
												<div class="dropzone-desc">
													<i class="camera"></i>
													<h6>Upload Shop Photo</h6>													
												</div>
												<input type="file" name="fileup" class="dropzone"/>
											</div>											
										</div>
									</div>
								
								<div class="col-12">
									<button type="submit" class="btn btn-primary" id="">Proceed</button>
								</div>								
							</div>
							</form>							
						</div>
						
						<div class="col-12 col-lg-5 d-none d-lg-block">
							<div class="rightbanner"><img src={require('../../assests/images/register.png')} alt="Oxigen" class="img-fluid"/></div>
						</div>				
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
  )
}
